export function watermark(user_name) {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formattedTime = `${year}/${month}/${day} ${hours}:${minutes}`;
  const watermark = document.documentElement.querySelector(".watermark");
  watermark.style.backgroundImage = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="200" opacity="0.15"><text x="30" y="88" transform="rotate(-30 100,100)" font-family="Arial" font-size="18"> ${
    user_name + " " + formattedTime
  } </text></svg>')`;
}
